module.exports = __webpack_public_path__ + "img/tag_center.c07a15c7.svg";